<template>
  <div
    class="check-list-person auto-list_col_centered"
    @click.stop="$emit('open')"
  >
    {{ colorStatus }}
    <div>
      <p v-if="showStatus" class="date status" :class="colorStatus">
        {{ getStatus(response.status) }}
        {{ getStatusFio(response.status) }}
      </p>
      <p class="date">{{ getStatusDate(response) }}</p>
    </div>
  </div>
</template>

<script>
import { statuses } from '@/datas/responseStatuses'

export default {
  name: 'Date',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    setOpen: {
      type: Function,
      default: () => {},
    },
    showStatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      colorStatus: null,
    }
  },
  mounted() {
    // this.colorStatus = {
    //   info: this.response.status === 0,
    //   success: this.response.status === 1,
    //   warning: this.response.status === 2,
    //   danger: this.response.status === 3,
    // }
  },
  methods: {
    getStatus(status) {
      return status >= 0 && statuses[status] ? statuses[status].name : ''
    },
    getStatusFio(status) {
      if (
        status === 0 &&
        statuses[status] &&
        (this.isAdminOrCeoRole || this.isDispatcherRole)
      ) {
        return `от ${this.shortFio(this.response.user.fio) || 'Неизвестный'}`
      }
    },
    getStatusDate(res) {
      const raw = statuses[res.status]

      switch (res.status) {
        case 0:
          this.colorStatus = 'info'
          break
        case 1:
          this.colorStatus = 'success'
          break
        case 2:
          this.colorStatus = 'warning'
          break
        case 3:
          this.colorStatus = 'danger'
          break
        default:
          this.colorStatus = ''
      }

      return raw && raw.field
        ? this.dateToFormat(res[raw.field], 'respStatusDate')
        : ''
    },
  },
}
</script>

<style lang="sass">
.bids-list .middle-section .check-list .check-list-person
  .date
    font-size: 15px
    line-height: 14px
    color: #8694A4
    margin: 10px 0
    &.status
      text-decoration: underline
    &.info
      color: #909399
    &.success
      color: #67C23A
    &.warning
      color: #E6A23C
    &.danger
      color: #F56C6C
</style>
